import React from 'react';

import AppAnnieSvg from '@gp/assets/svg/datasource-icon/AppAnnie.svg';
import NewzooSvg from '@gp/assets/svg/datasource-icon/Newzoo.svg';
// import SensorTowerSvg from '@gp/assets/svg/datasource-icon/SensorTower.svg';

function bubbleContent(platform: 'mobile' | 'pc' | 'console') {
  switch (platform) {
    case 'mobile':
      return (
        <section className="overview-live-card-platform-bubble">
          Data of MAU comes from
          &nbsp;<img width={18} height={18} src={AppAnnieSvg} alt="" />&nbsp;
          App Annie.
        </section>
      );

    case 'pc':
      return (
        <section className="overview-live-card-platform-bubble">
          Data of MAU comes from
          &nbsp;<img width={18} height={18} src={NewzooSvg} alt="" />&nbsp;
          Newzoo.
        </section>
      );

    case 'console':
      return (
        <section className="overview-live-card-platform-bubble">
          Data of MAU comes from
          &nbsp;<img width={18} height={18} src={NewzooSvg} alt="" />&nbsp;
          Newzoo.
        </section>
      );

    default:
      return undefined;
  }
}

export {
  bubbleContent,
}
